import { render, staticRenderFns } from "./_autoAssignDelegatesToTasksField.vue?vue&type=template&id=3f4e999b"
import script from "./_autoAssignDelegatesToTasksField.vue?vue&type=script&lang=js"
export * from "./_autoAssignDelegatesToTasksField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports